import { defineStore } from 'pinia'
import { mergeOptionsParams, useCreateForm, useEditForm } from "@/stores/_helpers.js";
import toasteventbus from 'primevue/toasteventbus';

export const usePermissionsStore = defineStore('permissions', {
  state: () => ({
    data: undefined,
    options: undefined,
  }),
  getters: {
    getPermissions: (state) => state.data?.data,
    getPermissionOptions: (state) => state.options?.data,
    getPermissionsGroupedByResource: (state) => {
      const groupedPermissions = state.data?.data
          ?.filter(p => {
            const [action] = p.name.split(':', 1);
            return ['create', 'read', 'update', 'delete'].includes(action);
          })
          .reduce((previous, permission) => {
            const [action, resource] = permission.name.split(':', 2);
            if (!previous.hasOwnProperty(resource)) {
              previous[resource] = {
                create: null,
                read: null,
                update: null,
                delete: null,
              };
            }
            previous[resource][action] = {
              ...permission,
              action,
            };
            return previous;
          }, {}) || {};

      // sort the keys on the object
      return Object.fromEntries(Object.entries(groupedPermissions).sort());
    }
  },
  actions: {
    /**
     * This method should be used to return as little data as possible for use in select boxes
     *
     * @param params
     * @param silent
     * @returns {Promise<any>}
     */
    async indexPermissionOptions(params = {}, silent = true) {

      if (!silent)
        this.options = undefined;

      try {
        if (!this.options) {
          let qryParams = mergeOptionsParams(params, 'permissions', ['id', 'name', 'display_name', 'description']);
          const response = await axios.get('permissions', {params: qryParams});
          this.options = response.data;
        }

        return this.options;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async indexPermissions(params = {}) {
      try {
        const response = await axios.get('permissions', {params});
        this.data = response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async createPermission(params = {}) {
      try {
        const response = await axios.get('permissions/create', {params});
        return useCreateForm('permissions', response.data, { onFinish: () => this.options = undefined });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async showPermission(permissionId, params = {}) {
      try {
        const response = await axios.get(`permissions/${ permissionId }`, {params});
        return response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async editPermission(permissionId, params = {}) {
      try {
        const response = await axios.get(`permissions/${ permissionId }/edit`, {params});
        return useEditForm(`permissions/${ permissionId }`, response.data, { onFinish: () => this.options = undefined });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async deletePermission(permissionId, params = {}) {
      try {
        const response = await axios.delete(`permissions/${ permissionId }`, {params});
        this.options = undefined;
        toasteventbus.emit('add', {
          summary: 'Permission Deleted',
          detail: `Permission has been deleted.`,
          severity: 'success',
          life: 3000
        });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
  },
});
